<template>
  <v-btn
    color="success"
    min-height="35"
    min-width="120"
    rounded
    @click="finalizarInclusao()"
    :loading="carregando"
    >Finalizar</v-btn
  >
</template>

<script>
import axios from "axios";
import { mapGetters, mapState } from "vuex";
import { getBase64 } from "@/global";
export default {
  computed: {
    ...mapState("atestado", ["configs"]),
    ...mapState("dependentes", ["dependenteEnviar", "dependenteSelec"]),
    ...mapState("anexos", ["docs"]),
  },
  data: () => ({
    carregando: false,
  }),
  methods: {
    ...mapGetters("dependentes", ["getConfigDocs"]),
    async finalizarInclusao() {
      if (this.dependenteEnviar.inativarDepend && this.dependenteSelec) {
        this.carregando = true;
        await axios
          .post(
            "/colaborador/dependentes?funcao=inativardependente",
            JSON.stringify({
              ambiente: "WEB",
              cod_dependente: this.dependenteSelec.codigo,
              observacao: this.dependenteEnviar.observacao,
            }),
          )
          .then((res) => {
            if (res.data.success) {
              this.$router.push({ name: "dependentes" });
              this.$toasted.success(res.data.msg);
            } else this.$toasted.error(res.data.msg);
          })
          .catch((e) => this.$toasted.error(e));
        this.carregando = false;
        return;
      }

      var qtdeDocsObrig = this.getConfigDocs().filter(
        (cfg) => cfg.obrigatorio,
      ).length;
      var qtdeDocsObrigAnexados = 0;

      if (this.dependenteSelec) {
        qtdeDocsObrigAnexados = this.docs.filter(
          (doc) => doc.obrigatorio && doc.alterar,
        ).length;
      } else {
        qtdeDocsObrigAnexados = this.docs.filter(
          (doc) => doc.obrigatorio && doc.incluir,
        ).length;
      }

      if (qtdeDocsObrig != qtdeDocsObrigAnexados) {
        this.$toasted.error("Os documentos obrigatórios precisam ser anexados");
        this.carregando = false;
        return;
      }
      this.carregando = true;

      var codDepend = 0;
      if (this.dependenteSelec) {
        if (this.dependenteSelec.cadexistehcm) {
          codDepend = this.dependenteSelec.codigo;
        }
      }

      var data = {
        codigotipo: this.configs.find((config) => config.cadastdependente)
          .codigo,
        codigomotivo: this.getConfigDocs().find(
          (config) => config.codsituacao > 0,
        ).codsituacao,
        nome: this.dependenteEnviar.nome,
        nacimento: this.dependenteEnviar.dtNascimento,
        dependenteir: this.dependenteEnviar.depImpostoRenda,
        dependentesf: this.dependenteEnviar.depSalarioFamilia,
        coddependente: codDepend,
        observacao: this.dependenteEnviar.observacao,
        ambiente: "WEB",
        incluir: false,
      };

      var param = "";
      if (this.dependenteSelec) {
        param = `&codigo=${this.dependenteSelec.codatestado}&existehcm=${this.dependenteSelec.cadexistehcm}`;
      }

      data.filenames = [];
      for (const doc of this.docs) {
        data.filenames.push({
          id: doc.codigo,
          doc: await getBase64(doc.file[0]),
        });
      }

      /*const json = JSON.stringify(data);
      const blob = new Blob([json], {
        type: "application/json",
      });

      let formData = new FormData();
      this.docs.forEach((anexo) => {
        if (anexo.file)
          formData.append(anexo.codigo, anexo.file[0], anexo.file.name);
      });
      formData.append("data", blob);*/

      await axios
        .post(
          `/colaborador/dependentes?funcao=atualizardependente${param}`,
          data,
        )
        .then((res) => {
          if (res.data.success) {
            this.$router.push({ name: "dependentes" });
            this.$toasted.success(
              "Solicitação de dependente finalizada com sucesso!",
            );
          } else this.$toasted.error(res.data.msg);
        })
        .catch((e) => this.$toasted.error(e));
      this.carregando = false;
    },
  },
};
</script>

<style></style>
